<template>
  <v-row >
    <v-col cols="12" v-if="!myMessage">
      <v-row align="end" class="pl-2">
        <div class="pl-4 pr-2">

          <v-avatar size=36>
            <img :src="message.avatar" alt="avatar">
          </v-avatar>

        </div>
        <v-col shrink class="primary white--text px-3 py-2" style="border-radius:15px; max-width: 60%" align="start">
          <div v-if="!message.picture">{{ message.messageText }}</div>
          <v-img v-else :src="message.picture" @click="previewDialog =true" >

          </v-img>
          <div class="caption">
            {{ message.timeStamp|formatDateTime }}
          </div>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" v-else align="end">
      <v-row align="end" justify="end" class="pr-6">

        <v-col shrink :class="`${message.picture?'':'blue'} white--text  py-2`" style="border-radius:15px; max-width: 60%" align="start">
          <div v-if="!message.picture">{{ message.messageText }}</div>
          <v-img v-else :src="message.picture" @click="previewDialog =true" >

          </v-img>
          <div class="caption">
            {{ message.timeStamp|formatDateTime }}
          </div>
        </v-col>
      </v-row>
    </v-col>
    <v-dialog
      v-model="previewDialog"
      modal
      max-width="500px"
      transition="dialog-transition"
    >
  <v-img :src="message.picture"></v-img>
    </v-dialog>
  </v-row>
</template>

<script>
import {
  mapState
} from 'vuex'
import moment from 'moment'

export default {
  props: {
    message: {
      required: true
    },
    avatar: {
      type: String
    },
    isHefe: {
      type: Boolean
    }
  },
  data () {
    return {
      previewDialog: false
    }
  },
  // mounted () {
  //   console.log(this.message)
  // },
  methods: {
    previewPicture () {
      this.previewDialog = true
    }
  },
  computed: {
    ...mapState(['currentUser', 'userProfile']),
    myMessage () {
      if (this.currentUser) {
        return this.message.profileId === this.currentUser.uid
      }
      return false
    }
  },
  filters: {
    formatDateTime (val) {
      if (!val) {
        return '-'
      }
      let date = new Date(val)
      return moment(date).fromNow()
    }
  }
}
</script>
